import { gql } from '@apollo/client';

export const TEST_SESSION_NOTES = gql`
  query TestSessionNotes (
    $companyId: ID!,
    $noteType: TestSessionNotesEnum!,
    $limit: Int!,
    $skip: Int!,
    $order: String!,
    $search: String,
    $projectIds: [ID!],
    ) {
    testSessionNotes(
      companyId: $companyId,
      noteType: $noteType,
      limit: $limit,
      skip: $skip,
      order: $order,
      search: $search,
      projectIds: $projectIds,
    ) {
      id
      videoUrl
      status
      note
      createdAt
      videoStartTime
      videoEndTime
      testSession {
        id
        tester {
          id
          user {
            id
            profile {
              id
              firstName
            }
          }
          project {
            id
            name
          }
        }
      }
      createdBy {
        id
        profile {
          id
          firstName
        }
      }
    }
  }
`;

export const HIGHLIGHT_REELS = gql`
  query HighlightReels($companyId: ID!, $limit: Int!, $offset: Int!, $order: String!, $search: String) {
    highlightReels(companyId: $companyId, limit: $limit, offset: $offset, order: $order, search: $search) {
      id
      title
      createdBy {
        id
        profile {
          id
          firstName
        }
      }
      company {
        id
        name
      }
      createdAt
      totalClips
      totalDuration
      videoUrl
    }
  }
`;

export const GET_PROJECTS_BY_COMPANY = gql`
  query Projects($companyId: ID!) {
    projects(companyId: $companyId) {
      id
      name
    }
  }
`;
